import Header from '../../../__Layout/Header';
import React, { useState, useEffect } from 'react'
import Loader from '../../../utils/Loader';
import { useGetStudentCourseOutcomePdfQuery } from "../../../Services/api";
import { pageUrl } from "../../../utils/constants/constants";
import { Link, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useSaveStudentTimeMutation } from "../../../Services/api";
import { toast } from 'react-toastify';

import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { pdfjs } from 'react-pdf';
import pdfWorker from 'pdfjs-dist/build/pdf.worker.entry';
export default function PaidCourseReading() {

  const { lpd_id, lpid, unit } = useParams();

  const lpidParam = 'lpd_id=' + lpd_id;
  const { userDetail } = useSelector((state) => state.auth)
  const [studentId, setStudentId] = useState("")

  useEffect(() => {
    if (userDetail) {
      setStudentId(userDetail['user'][0]['student_id'])
    }
  }, [userDetail])
  const [time, setTime] = useState({
    sec: 0,
    min: 0,
    hr: 0
  });


  const updateTimer = () => {
    setTime((prev) => {
      let newTime = { ...prev };
      // update sec and see if we need to increase min
      if (newTime.sec < 59) newTime.sec += 1;
      else {
        newTime.min += 1;
        newTime.sec = 0;
      }
      // min has increased in *newTime* by now if it was updated, see if it has crossed 59
      if (newTime.min === 60) {
        newTime.min = 0;
        newTime.hr += 1;
      }

      return newTime;
    });
  };
  const [startReading, setStartReading] = useState('Start Reading');
  const [intervalId, setIntervalId] = useState(0);
  const [intervalTime, setIntervalTime] = useState();
  const [SaveStudentTime] = useSaveStudentTimeMutation();
  const notify = () => '';
  const pauseOrResume = () => {
    if (intervalId == 0) {
      setStartReading('Save Reading');
      let id = setInterval(updateTimer, 1000);
      setIntervalId(1);
      setIntervalTime(id);
    } else {
      clearInterval(intervalTime);
      setStartReading('Start Reading');
      setIntervalId(0);
    }
    const h2Element = document.querySelector('h4'); // Get the h2 element
    let values = [];
    if (h2Element) {
      const text = h2Element.textContent; // Get the text content of the h2 element
     // Update the state with the text
      values.time = text;
    }
    //  values.time = h2Text;
    values.lpid = lpid;
    values.unit = unit;
    values.student_id = studentId;
    if (intervalId == 1) {
      // alert("please read clearly your study time is = \n"+values.time +"\n otherwise click on save button again");
      SaveStudentTime({ data: values })
        .unwrap()
        .then((payload) => {
          if (payload.status) {
            toast.success(payload.message)
          } else {
            toast.error(payload.message)
          }
        })
        .catch((error) => {
          toast.error(error.data.message)
        });
      notify();
    }
  };
  ////////////done/////
  const {
    data: CourseOutcome,
    isLoading: isGetLoading,
  } = useGetStudentCourseOutcomePdfQuery({ pageUrl, params: lpidParam });
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const scale = window.devicePixelRatio > 1 ? window.devicePixelRatio : 1.5;  
  if (isGetLoading) return <Loader></Loader>
  return (
    <div className="vehicleCategories">
      <Header />
      <main id="main" className="main">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Course Pdf Reading</h5>
            <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
              <li>
                <Link to={`/student-course-outcome/${lpid}/${unit}`} className='btn btn-dark'>
                  Back
                </Link>
              </li>
              <li>
                <h4>{`${time.hr < 10 ? 0 : ""}${time.hr}:${time.min < 10 ? 0 : ""}${time.min}:${time.sec < 10 ? 0 : ""}${time.sec}`}</h4>
              </li>
              <li>
                <button className="btn btn-dark float-right pull-right" onClick={pauseOrResume}> {startReading}</button>
              </li>
            </ul>
            <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
              <li className="nav-item flex-fill" role="presentation">
                {CourseOutcome?.learning_outcome?.map((item, index) => {
                  return (
                    <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">{item.bullet_point}</button>
                  )
                })
                }
              </li>
            </ul>
            <div className="tab-content pt-2"  >
              {CourseOutcome?.learning_outcome?.map((item, index) => {
                return (
                  <>
                    <div className='col-md-12 col-xs-12 col--12 border' key={index}>
                      <Worker style={{ maxWidth: '100%', height: 'auto' }} workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                        {/* <Viewer fileUrl={encodeURI(item.file_name)} renderMode="svg" renderPageProps={{ scale: scale, resolution: 150 }} /> */}
                        <div style={{
                          border: '1px solid rgba(0, 0, 0, 0.3)',
                          height: '750px',
                        }}>
                          <Viewer fileUrl={item.file_name} scale={scale} />
                        </div>
                      </Worker>
                    </div>
                  </>
                )
              })
              }
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}